import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import NewCustomers from './NewCustomers';
import ProductDelivery from './ProductDelivery';
import StockReport from './StockReport';
import TopCategories from './TopCategories';
import TopProducts from './TopProducts';
import TopSalesLocation from './TopSalesLocation';
import Widgets from './Widgets';
import Revenue from './Revenue';
import RecentOrdersComponent from './RecentOrders';

const Dashboard = () => {

    document.title = "Vendor Dashboard | AeroPartX";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col xxl={12} lg={6} className="order-first">
                            <Row className="row-cols-xxl-4 row-cols-1">
                                <Widgets />
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <RecentOrdersComponent />
                    </Row>
                    <Row className='widget-responsive-fullscreen'>
                        {/* <CustomerSatisfaction /> */}
                        <StockReport />
                        <TopCategories />
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Dashboard;
